(function () {
  // Performance-first version:
  // keep the file in place so theme references do not break,
  // but disable all heavy View Transition logic.

  // If the theme injected a render blocker element, remove it immediately.
  var blocker = document.getElementById('view-transition-render-blocker');
  if (blocker) blocker.remove();

  function hasViewTransition(event) {
    return !!(event && 'viewTransition' in event && event.viewTransition);
  }

  function skip(event) {
    if (!hasViewTransition(event)) return;
    try {
      event.viewTransition.skipTransition();
    } catch (e) {}
  }

  window.addEventListener('pageswap', skip, { passive: true });
  window.addEventListener('pagereveal', skip, { passive: true });
})();